import React, { Fragment } from 'react';
import { css } from 'styled-components';

import ValuePropBase from './ValuePropBase';
import { breakpoints } from '../../constants/styles';
import Helmet from 'react-helmet';

const StyledTitle = css`
  max-width: 400px;

  ${breakpoints.tablet} {
    text-align: center;
  }

  ${breakpoints.tabletLandscape} {
    text-align: left;
  }
`;

const Deuda = () => (
  <Fragment>
    <Helmet>
      <title>{'Finauta | Deuda'}</title>
    </Helmet>
    <ValuePropBase
      tool="deuda"
      title="Descubre cuánto podrías ahorrarte por cambiar tu deuda"
      titleStyles={StyledTitle}
    />
  </Fragment>
);

export default Deuda;
